import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { getFont } from '../helpers/dataTransformer'
import { getItemColorTheme, getItemValue } from '../helpers/itemHelper'
import colors from '../lib/colors'
import { CurrencyCode } from '../types/API'
import {
  GiftItemStatus,
  IColorTheme,
  IGiftItemResponse,
} from '../types/itemTypes'
import { Font } from '../types/organisation'
import { getTicketPrice } from './helpers/itemPrice'

const Styles = styled.div`
  background-color: ${colors.lightestGray};
  width: 237px;
  display: flex;
  margin: auto;
  font-size: 12px;
  font-family: ${(props): string => props.theme};
  box-shadow: 0px 2px 4px ${colors.shadow};

  > div {
    padding: 3px 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`
const Image = styled.div`
  min-height: 80px;
  min-width: 105px;
  background: url(${(props): string => props.theme.imageUrl});
  background-size: cover;
  background-position: center;
  background-color: ${(props): string => props.theme.colorTheme.colourPriceText};
`
const Name = styled.div`
  max-height: 51px;
  overflow: hidden;
`
const Price = styled.div`
  font-weight: bold;
  color: ${(props): string => props.theme.colourPriceText};
`

type Props = {
  giftItem: IGiftItemResponse
  currency: CurrencyCode
  individuals: number
  organisationColors?: IColorTheme
  font?: Font
}
export default function CompactItem(props: Props): ReactElement {
  const {
    giftItem: { name, imageUrl, value, prices },
    currency,
    individuals,
    organisationColors,
    font,
  } = props

  const hasPrices = prices && prices.length > 0

  const colorTheme = getItemColorTheme(organisationColors)

  const isMonetary = value?.includes(',')
  const price = isMonetary ? value : (Number(value) * individuals).toString()

  const activePrices = [...(prices || [])].filter(
    ({ status }) => status === GiftItemStatus.Published,
  )

  const itemValue = getItemValue(price, currency)
  const itemMultiValue = getTicketPrice(activePrices, currency)

  return (
    <Styles theme={getFont(font)}>
      <Image theme={{ colorTheme, imageUrl }} />
      <div>
        <Name>{name}</Name>
        <Price theme={colorTheme}>
          {hasPrices ? itemMultiValue : itemValue}
        </Price>
      </div>
    </Styles>
  )
}
